import React, {useState} from 'react';
import {Popover, PopoverBody} from "reactstrap";
import "./index.css";
import PropTypes from "prop-types";
import DropdownItem from "../../../broadcaster/library/dropdown-item/DropdownItem";
import assets from "../../../../../util/assets";

CommentDropDown.propTypes = {
    dropDownItem: PropTypes.array.isRequired,
    commentId: PropTypes.string.isRequired,
};

CommentDropDown.defaultProps = {
    dropDownItem: [{
        slug: 'report',
        title: "Report",
        icon: assets.messaging.dropdown.report,
        action: () => {
            console.log("Report")
        }
    }]
}

function CommentDropDown(props) {

    const [popoverOpen, setPopoverOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const toggle = () => {
        console.log("popoverOpen",popoverOpen)
        setPopoverOpen(!popoverOpen)
    };


    return (
        <div>
            <img
                className="cursor-pointer padding-16"
                src={popoverOpen ? assets.messaging.dropdown.icon.active : assets.messaging.dropdown.icon.inactive}
                id={`comment-more-${props.commentId}`}/>

            <Popover placement="bottom"
                     isOpen={popoverOpen}
                     target={`comment-more-${props.commentId}`}
                     toggle={toggle}
                     className="chat-window-detail-header-popover">

                <PopoverBody className="my-library-actions-pop-over-body">
                    <div>
                        {
                            props.dropDownItem.map((item, index) => {

                                return (
                                    <DropdownItem
                                        isFetching={props.isFetching && selectedItem === item}
                                        key={`chat-window-dropdown-item-${index}`}
                                        onClick={() => {
                                            setPopoverOpen(false);
                                            setSelectedItem(item)
                                            item.action();
                                        }}
                                        icon={item.icon}
                                        text={item.title}
                                    />
                                )

                            })
                        }
                    </div>
                </PopoverBody>
            </Popover>
        </div>
    );
}

export default CommentDropDown;